/* ============================================================
   Howard Wire — theme.js
   Progressive enhancement: quote-cart count, cart quantity edits,
   contact tabs, product variant URL, and the quote wizard.
   ============================================================ */
(function () {
  'use strict';

  /* ---- Buy cart count in the top bar (real Shopify cart). The QUOTE count is
         owned by the separate localStorage quote lane below (HWQuote). ---- */
  function updateCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') { return; }
        document.querySelectorAll('#BuyCartCount, [data-buy-count]').forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartCount);
  } else { updateCartCount(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') !== -1) { setTimeout(updateCartCount, 500); }
  });

  /* ---- Cart line quantity edits (quote cart) ---- */
  function rebuildQuoteItems(cart) {
    var hid = document.querySelector('input[name="contact[Quote Items]"]');
    if (hid && cart && cart.items) {
      hid.value = cart.items.map(function (it) {
        return (it.sku || it.product_title) + ' ×' + it.quantity + ' — ' + it.product_title;
      }).join(' // ');
    }
  }
  function changeLine(input, qty) {
    var line = input.getAttribute('data-line');
    if (!line) return;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(); rebuildQuoteItems(cart);
      if (qty === 0) {
        if (cart.item_count === 0) { window.location.reload(); return; }
        var row = input.closest('.cart-row'); if (row) { row.parentNode.removeChild(row); }
      } else { input.value = qty; }
    }).catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest && e.target.closest('[data-qty-up], [data-qty-down]');
    if (stepBtn) {
      var wrap = stepBtn.closest('[data-cart-qty]');
      var input = wrap && wrap.querySelector('.qty-input');
      if (input) {
        var v = parseInt(input.value, 10); if (isNaN(v)) { v = 0; }
        v += stepBtn.hasAttribute('data-qty-up') ? 1 : -1; if (v < 0) { v = 0; }
        if (input.hasAttribute('data-line')) { changeLine(input, v); } else { input.value = v; }
      }
      return;
    }
    /* Contact form tabs */
    var tab = e.target.closest && e.target.closest('.tab[data-tab]');
    if (tab) {
      var key = tab.getAttribute('data-tab');
      tab.parentNode.querySelectorAll('.tab').forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      document.querySelectorAll('.form-pane[data-pane]').forEach(function (p) {
        p.classList.toggle('active', p.getAttribute('data-pane') === key);
      });
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input.classList && input.classList.contains('qty-input') && input.hasAttribute('data-line')) {
      var v = parseInt(input.value, 10); if (isNaN(v) || v < 0) { v = 0; }
      changeLine(input, v);
    }
    /* Product variant → reflect in URL */
    if (input.tagName === 'SELECT' && input.name === 'id' && input.form && input.form.id === 'ProductForm') {
      if (input.value && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        history.replaceState({}, '', url.toString());
      }
    }
  });

  /* ---- Quote wizard (Cart → Contact → Ship-To → Review) ---- */
  (function () {
    var wizard = document.getElementById('QuoteWizard');
    var form = document.getElementById('QuoteForm');
    if (!wizard || !form) return;
    var panes = form.querySelectorAll('.pane[data-pane]');
    if (!panes.length) return; /* confirmation view has no panes */
    var steps = document.querySelectorAll('.stepper .step[data-step]');
    var progress = document.getElementById('QuoteProgress');
    var total = panes.length, current = 1;

    function fieldByName(n) { return form.querySelector('[name="' + n + '"]'); }

    function populateReview() {
      form.querySelectorAll('[data-review]').forEach(function (el) {
        var name = el.getAttribute('data-review'), val = '';
        var checked = form.querySelector('[name="' + name + '"]:checked');
        if (checked) { val = checked.value; }
        else { var f = fieldByName(name); if (f) { val = f.value; } }
        el.textContent = val || '—';
      });
      var shipto = form.querySelector('[data-review-shipto]');
      if (shipto) {
        function v(n) { var f = fieldByName(n); return f ? f.value.trim() : ''; }
        var parts = [v('contact[Ship Company]'), v('contact[Street]'), (v('contact[City]') + ' ' + v('contact[State / ZIP]')).trim()].filter(Boolean);
        shipto.innerHTML = parts.length ? parts.join('<br>') : '—';
      }
    }
    function validate(n) {
      var pane = form.querySelector('.pane[data-pane="' + n + '"]'); if (!pane) return true;
      var ok = true, first = null;
      pane.querySelectorAll('[data-req]').forEach(function (f) {
        var bad = !f.value.trim() || (f.type === 'email' && f.value.indexOf('@') < 1);
        f.style.borderColor = bad ? 'var(--hw-red)' : '';
        if (bad && !first) { first = f; } if (bad) { ok = false; }
      });
      if (first) { first.focus(); }
      return ok;
    }
    function show(n) {
      current = Math.max(1, Math.min(total, n));
      panes.forEach(function (p) { p.classList.toggle('active', parseInt(p.getAttribute('data-pane'), 10) === current); });
      steps.forEach(function (s) {
        var sn = parseInt(s.getAttribute('data-step'), 10);
        s.classList.toggle('active', sn === current);
        s.classList.toggle('done', sn < current);
      });
      if (progress) { progress.style.width = ((current - 1) / (total - 1) * 75) + '%'; }
      if (current === total) { populateReview(); }
      var anchor = document.querySelector('.stepper') || wizard;
      window.scrollTo({ top: anchor.offsetTop - 16, behavior: 'smooth' });
    }

    wizard.addEventListener('click', function (e) {
      if (e.target.closest('[data-next]')) { if (validate(current)) { show(current + 1); } }
      else if (e.target.closest('[data-prev]')) { show(current - 1); }
      else if (e.target.closest('[data-goto]')) { show(parseInt(e.target.closest('[data-goto]').getAttribute('data-goto'), 10)); }
      else {
        var card = e.target.closest('.radio-card');
        if (card) {
          card.parentNode.querySelectorAll('.radio-card').forEach(function (c) { c.classList.remove('checked'); });
          card.classList.add('checked');
          var r = card.querySelector('input[type=radio]'); if (r) { r.checked = true; }
        }
      }
    });
    steps.forEach(function (s) {
      s.style.cursor = 'pointer';
      s.addEventListener('click', function () {
        var n = parseInt(s.getAttribute('data-step'), 10);
        if (n <= current) { show(n); } else if (validate(current)) { show(current + 1); }
      });
    });
    show(1);
  })();
})();

/* ============================================================
   Predictive search — search-as-you-type on any search box
   (catalog filter bar + /search page). Uses Shopify's suggest API.
   ============================================================ */
(function () {
  'use strict';
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML; }
  var inputs = document.querySelectorAll('input[type="search"][name="q"]');
  Array.prototype.forEach.call(inputs, function (input) {
    var parent = input.parentElement || input;
    if (getComputedStyle(parent).position === 'static') { parent.style.position = 'relative'; }
    var box = document.createElement('div');
    box.className = 'psearch-results';
    box.setAttribute('hidden', '');
    parent.appendChild(box);
    input.setAttribute('autocomplete', 'off');
    var timer;
    function close() { box.setAttribute('hidden', ''); box.innerHTML = ''; }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=7', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (((data || {}).resources || {}).results || {}).products || [];
            var html = '';
            products.forEach(function (p) {
              var sub = p.product_type || p.vendor || '';
              html += '<a class="psearch-item" href="' + p.url + '">' +
                        '<span class="psearch-title">' + esc(p.title) + '</span>' +
                        (sub ? '<span class="psearch-sub">' + esc(sub) + '</span>' : '') +
                      '</a>';
            });
            html += '<a class="psearch-all" href="/search?q=' + encodeURIComponent(q) + '">' +
                      (products.length ? 'See all results for "' + esc(q) + '" →' : 'No matches — search the full catalog →') +
                    '</a>';
            box.innerHTML = html;
            box.removeAttribute('hidden');
          })
          .catch(function () { close(); });
      }, 200);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); } });
    document.addEventListener('click', function (e) { if (!box.contains(e.target) && e.target !== input) { close(); } });
  });
})();

/* ============================================================
   Quote lane — a SEPARATE quote cart stored in the browser
   (localStorage), independent of the real Shopify (buy) cart.
   "Add to Quote" buttons add here; the /pages/quote wizard reads
   here and emails it. The Shopify cart is reserved for buyable
   ("for-sale") items + real checkout.
   ============================================================ */
(function () {
  'use strict';
  var KEY = 'hw_quote_v1';
  function esc(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML; }
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(items) { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} sync(); }
  function count() { return read().reduce(function (n, i) { return n + (i.qty || 1); }, 0); }
  function add(it) {
    var items = read(), found = null, i;
    for (i = 0; i < items.length; i++) { if (items[i].key === it.key) { found = items[i]; break; } }
    if (found) { found.qty += it.qty; } else { items.push(it); }
    write(items);
  }
  function remove(key) { write(read().filter(function (i) { return i.key !== key; })); }
  function setQty(key, qty) { read(); var items = read(); items.forEach(function (i) { if (i.key === key) { i.qty = Math.max(1, qty); } }); write(items); }
  function clear() { write([]); }
  window.HWQuote = { read: read, add: add, remove: remove, setQty: setQty, clear: clear, count: count };

  /* ---- "Add to Quote" intercept (product page) ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-add-to-quote]') : null;
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('form'), id = '', qty = 1, title = btn.getAttribute('data-title') || '', url = btn.getAttribute('data-url') || '', variant = '', sku = '', img = '';
    if (form) {
      var idEl = form.querySelector('[name="id"]'); if (idEl) id = idEl.value;
      var qEl = form.querySelector('[name="quantity"]'); if (qEl) qty = Math.max(1, parseInt(qEl.value || '1', 10) || 1);
    }
    var pj = document.querySelector('[data-product-json]'), product = null;
    try { if (pj) product = JSON.parse(pj.textContent); } catch (er) {}
    if (product) {
      title = product.title || title; url = product.url || url;
      var v = null, k;
      for (k = 0; k < (product.variants || []).length; k++) { if (String(product.variants[k].id) === String(id)) { v = product.variants[k]; break; } }
      if (!v && product.variants) { v = product.variants[0]; }
      if (v) {
        id = v.id; sku = v.sku || '';
        if (v.title && v.title !== 'Default Title') { variant = v.title; }
        img = (v.featured_image && v.featured_image.src) || '';
      }
      if (!img) { img = (typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image && product.featured_image.src)) || (product.images && product.images[0]) || ''; }
    }
    if (!id) { return; }
    add({ key: String(id), id: String(id), title: title, variant: variant, sku: sku, url: url, image: img, qty: qty });
    var orig = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', orig); btn.textContent = 'Added to Quote ✓'; btn.classList.add('added');
    setTimeout(function () { btn.textContent = orig; btn.classList.remove('added'); }, 1600);
  });

  /* ---- Quote page render ---- */
  function renderPage(root) {
    if (root.querySelector('.confirm.active')) { return; } // post-submit confirmation
    var items = read(), empty = root.querySelector('#QuoteEmpty'), flow = root.querySelector('#QuoteFlow');
    if (!items.length) { if (empty) empty.hidden = false; if (flow) flow.hidden = true; return; }
    if (empty) empty.hidden = true; if (flow) flow.hidden = false;
    var n = count();
    root.querySelectorAll('[data-quote-itemcount]').forEach(function (el) { el.textContent = n + ' item' + (n !== 1 ? 's' : ''); });
    var list = root.querySelector('#QuoteList');
    if (list) {
      list.innerHTML = items.map(function (it) {
        return '<div class="cart-row" data-key="' + esc(it.key) + '">' +
          '<a class="cart-thumb" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(it.image) + '" width="80" height="80" alt="' + esc(it.title) + '">' : '') + '</a>' +
          '<div class="cart-info">' + (it.sku ? '<div class="cart-sku">SKU · ' + esc(it.sku) + '</div>' : '') +
            '<div class="cart-title"><a href="' + esc(it.url) + '">' + esc(it.title) + '</a></div>' +
            (it.variant ? '<div class="cart-specs">' + esc(it.variant) + '</div>' : '') + '</div>' +
          '<div><div class="cart-controls"><button type="button" class="qty-btn" data-q-down aria-label="Decrease">−</button>' +
            '<input class="qty-input" type="number" min="1" value="' + (it.qty || 1) + '" data-q-input aria-label="Quantity">' +
            '<button type="button" class="qty-btn" data-q-up aria-label="Increase">+</button></div></div>' +
          '<a class="cart-remove" href="#" data-q-remove title="Remove" aria-label="Remove ' + esc(it.title) + '">✕</a></div>';
      }).join('');
    }
    var rev = root.querySelector('#QuoteReviewList');
    if (rev) {
      rev.innerHTML = items.map(function (it) {
        return '<div class="review-cart-row"><div class="review-cart-thumb">' + (it.image ? '<img src="' + esc(it.image) + '" width="44" height="44" alt="">' : '') + '</div>' +
          '<div class="review-cart-mid"><div class="review-cart-sku">' + esc(it.sku || 'ITEM') + '</div><div class="review-cart-title">' + esc(it.title) + '</div></div>' +
          '<div class="review-cart-qty">' + (it.qty || 1) + '</div></div>';
      }).join('');
    }
    var field = root.querySelector('#QuoteItemsField');
    if (field) {
      field.value = items.map(function (it) { return (it.sku || it.title) + ' x' + (it.qty || 1) + ' - ' + it.title + (it.variant ? ' (' + it.variant + ')' : ''); }).join(' // ');
    }
  }

  /* ---- qty / remove on the quote page ---- */
  document.addEventListener('click', function (e) {
    var row = e.target.closest ? e.target.closest('.cart-row[data-key]') : null;
    if (!row) return;
    var key = row.getAttribute('data-key'), inp = row.querySelector('[data-q-input]'), cur = inp ? (parseInt(inp.value, 10) || 1) : 1;
    if (e.target.closest('[data-q-remove]')) { e.preventDefault(); remove(key); }
    else if (e.target.closest('[data-q-up]')) { setQty(key, cur + 1); }
    else if (e.target.closest('[data-q-down]')) { setQty(key, cur - 1); }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest ? e.target.closest('.cart-row[data-key] [data-q-input]') : null;
    if (!inp) return;
    var row = inp.closest('.cart-row[data-key]'); setQty(row.getAttribute('data-key'), parseInt(inp.value, 10) || 1);
  });

  /* ---- keep the hidden email field current right before submit ---- */
  var qf = document.getElementById('QuoteForm');
  if (qf) { qf.addEventListener('submit', function () {
    var root = document.querySelector('[data-quote-cart]'); if (root) renderPage(root);
    /* the reference number must exist BEFORE the post so it reaches the quote email */
    var ref = '#HW-' + new Date().getFullYear() + '-' + Math.floor(1000 + Math.random() * 9000);
    var rf = document.getElementById('QuoteRefField'); if (rf) { rf.value = ref; }
    try { localStorage.setItem('hw_quote_ref', ref); } catch (x) {}
  }); }

  /* ---- sync header count + quote page ---- */
  function sync() {
    var n = count();
    document.querySelectorAll('#QuoteCartCount, [data-quote-count]').forEach(function (el) { el.textContent = n; });
    var root = document.querySelector('[data-quote-cart]'); if (root) renderPage(root);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', sync); } else { sync(); }

  /* ---- clear the quote list after a successful submit (confirmation shown) ---- */
  if (document.querySelector('[data-quote-cart] .confirm.active')) { clear(); }
})();

/* ============================================================
   Buy cart (real Shopify cart at /cart) — AJAX quantity + remove
   with live totals, keyed by line item key so removals don't shift
   other lines. Independent of the localStorage quote lane above.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-buy-cart]');
  if (!root) return;
  function money(c) { return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function change(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('#BuyCartCount, [data-buy-count]').forEach(function (e) { e.textContent = cart.item_count; });
      if (cart.item_count === 0) { window.location.reload(); return; }
      root.querySelectorAll('[data-buy-subtotal]').forEach(function (e) { e.textContent = money(cart.total_price); });
      var byKey = {}; cart.items.forEach(function (it) { byKey[it.key] = it; });
      root.querySelectorAll('.cart-row[data-buy-key]').forEach(function (row) {
        var it = byKey[row.getAttribute('data-buy-key')];
        if (!it) { if (row.parentNode) { row.parentNode.removeChild(row); } return; }
        var lt = row.querySelector('[data-buy-line-total]'); if (lt) { lt.textContent = money(it.final_line_price); }
        var inp = row.querySelector('[data-buy-input]'); if (inp) { inp.value = it.quantity; }
      });
    }).catch(function () { window.location.reload(); });
  }
  root.addEventListener('click', function (e) {
    var row = e.target.closest ? e.target.closest('.cart-row[data-buy-key]') : null; if (!row) return;
    var key = row.getAttribute('data-buy-key'), inp = row.querySelector('[data-buy-input]'), cur = inp ? (parseInt(inp.value, 10) || 1) : 1;
    if (e.target.closest('[data-buy-remove]')) { e.preventDefault(); change(key, 0); }
    else if (e.target.closest('[data-buy-up]')) { change(key, cur + 1); }
    else if (e.target.closest('[data-buy-down]')) { change(key, Math.max(0, cur - 1)); }
  });
  root.addEventListener('change', function (e) {
    var inp = e.target.closest ? e.target.closest('.cart-row[data-buy-key] [data-buy-input]') : null; if (!inp) return;
    change(inp.closest('.cart-row[data-buy-key]').getAttribute('data-buy-key'), Math.max(0, parseInt(inp.value, 10) || 0));
  });
})();

/* Mobile header — hamburger toggles the nav drawer (≤760px). */
(function () {
  var bar = document.querySelector('.topbar');
  var burger = bar && bar.querySelector('.topbar-burger');
  if (!bar || !burger) return;
  function close() { bar.classList.remove('nav-open'); burger.setAttribute('aria-expanded', 'false'); }
  burger.addEventListener('click', function () {
    var open = bar.classList.toggle('nav-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
  // Close when a drawer link is tapped (the link still navigates).
  bar.addEventListener('click', function (e) {
    if (bar.classList.contains('nav-open') && e.target.closest('.topbar-nav a')) close();
  });
  // Close on Escape.
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
})();

/* Inventory filter "+ More …" dropdowns — jump to the chosen filter URL (mockup style). */
(function () {
  var bar = document.querySelector('.filterbar');
  if (!bar) return;
  bar.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('select.chip-dropdown[data-filter-more]') : null;
    if (sel && sel.value) window.location.href = sel.value;
  });
})();
